module.exports = __webpack_public_path__ + "img/timeline-01.4de4f6f2.jpg";